
  <div class="full-wraper">
    <div class="faq-page">
    <nav class="navbar navbar-expand-md navbar-dark bg-dark">
        <div class="sectpad container-fluid">   
            <!-- <a class="navbar-brand logomain logomainpge" href="javascript:void(0)">
                <img src="assets/images/logoheadpink.png" height="71" class="logo drag-drop">
                <img src="assets/images/logotxtpink.png" height="71" class="logo drag-drop">
                <img src="assets/images/logo-mbl.png" class="logo1"></a> -->
            <a class="navbar-brand logomain logomainpge" href="javascript:void(0)" routerLink="/">
                <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569491458/Static%20images/Logo/honest-gorilla_hduqh0.svg" height="60" class="logo logohead drag-drop" alt="Honest Gorilla">
                <img src="https://res.cloudinary.com/honest-gorilla/image/upload/v1569491925/Static%20images/Logo/logotxt_wfug7a.svg" class="logo1 mt-2"></a>
            <button  class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault"
                aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
                <img class="res-home-main" src="assets/images/list.png" width="18"  id="menuIcon" class="listicn">
            </button>
            <div class="collapse navbar-collapse" id="navbarsExampleDefault">
                <ul class="navbar-nav ml-auto webnav">
                    <li class="nav-item">
                        <a class="nav-link aboutshop" href="/" [ngx-scroll-to]="'#shopSection'">ABOUT</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="javascript:void(0)" routerLink="/commercial">SOLUTIONS</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="javascript:void(0)" routerLink="/giveback">GIVEBACK</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" href="javascript:void(0)" routerLink="/blog">RESOURCES</a>
                    </li>
                   
    
                </ul>
                <div class="mobilenav">
                    <!-- <div class="col-12 row m-0">
                        <div class="col-6 col-md mt-4 mb-2  pl-0">
                            <a class="btn btn-outline-primary loginmobile w-100" href="javascript:void(0)" routerLink="/login">LOGIN</a>
                        </div>
                        <div class="col-6 col-md mt-4 mb-2 pr-0">
                            <a href="javascript:void(0)" class="btnsec w-100 font14" routerLink="/getstarted">SHOP NOW</a>
                        </div>
                    </div> -->
                    <div class="col-12 row m-0 p-0">
                        <div class="col-6 col-md mb-2 mt-2">
                            <h5 class="font16 semi-bold" routerLink="/">ABOUT</h5>
                        </div>
                        <div class="col-6 col-md mb-2 mt-2">
                            <!-- <h5 class="font18" routerLink="/about">About</h5>
                            <a class="nav-link aboutshop p-0 font16 abtmbl semi-bold" href="#shopSection" (click)="mobhead($event)">About</a> -->
                            <h5 class="font16 semi-bold" routerLink="/commercial">SOLUTIONS</h5>
                        </div>
                    </div>
                    <div class="col-12 row m-0 p-0">
                        <div class="col-6 col-md mb-2 mt-2">
                            <h5 class="font16 semi-bold" routerLink="/giveback">GIVEBACK</h5>
                        </div>
                        <div class="col-6 col-md mb-2 mt-2">
                            <h5 class="font16 semi-bold" routerLink="/blog">RESOURCES</h5>
                        </div>
                    </div>
                </div>
            </div>
            <div class="webview"> 
                <a class="btn btn-wp-primary  mr-2 ml-2 login" routerLink="/login" >LOGIN</a>
                </div>
                <div class="mobileview"> 
                    <a class="btn btn-pw-primary mr-2 ml-2 login" routerLink="/get-started" >SHOP NOW</a>
                  </div>
            
            <a class="btn btn-pw-primary getstart" routerLink="/get-started">GET STARTED</a>
        </div>
    </nav>
    </div>
    <main role="main" class="maincnt mainmrg">
        <div class="container">
            <div class="row">
                <div class="col-md-12 text-center">
                    <h1 class="clrpink font62">404 - Page Not Found</h1>
                    <h5>Key to happiness: checking the URL or going <a href="https://www.honestgorilla.com/" target="_blank" >home</a> and trying again.</h5>
                    <img class="res-home-main mt-3" src="https://res.cloudinary.com/honest-gorilla/image/upload/v1574342675/Static%20images/404_vqqqfj.svg" width="110" >
                </div>
        </div>
        </div>
    </main>
    <app-footer></app-footer>
    </div>